export default "__VITE_ASSET__ClLS6UiG__"